export enum InfoBoxType {
  info,
  warning,
  error,
}
